export const nb = {
  meta: {
    locale: 'nb',
  },
  igaGeonorge: {
    data: {
      users: {
        'ingrid-solberg': {
          role: 'GIS-radgiver',
          department: 'Plan- og bygningsetaten',
        },
        'marius-lunde': {
          role: 'Dataforvalter',
          department: 'Bymiljoetaten',
        },
        'sara-holm': {
          role: 'Innleid prosjektleder',
          department: 'Vann- og avlopsetaten',
        },
        'erik-nordli': {
          role: 'Tilgangsforvalter',
          department: 'Utviklings- og kompetanseetaten',
        },
        'amalie-berg': {
          role: 'Kartdataanalytiker',
          department: 'Plan- og bygningsetaten',
        },
        'jonas-haugen': {
          role: 'Saksbehandler',
          department: 'Eiendoms- og byfornyelsesetaten',
        },
        'fatima-ali': {
          role: 'Integrasjonsansvarlig',
          department: 'Oslo Origo',
        },
        'anders-moen': {
          role: 'Systemeier',
          department: 'Bymiljoetaten',
        },
        'karoline-dahl': {
          role: 'Arkitekt',
          department: 'Plan- og bygningsetaten',
        },
        'thomas-ruud': {
          role: 'FDV-koordinator',
          department: 'Oslobygg KF',
        },
        'nora-aas': {
          role: 'Miljodataansvarlig',
          department: 'Klimaetaten',
        },
        'martin-eide': {
          role: 'Prosjektleder',
          department: 'Renovasjon- og gjenvinningsetaten',
        },
        'silje-bakken': {
          role: 'Fagkonsulent',
          department: 'Utdanningsetaten',
        },
        'hassan-hussain': {
          role: 'Kommunal datadeler',
          department: 'Helseetaten',
        },
        'eline-vik': {
          role: 'Innkjopsradgiver',
          department: 'Utviklings- og kompetanseetaten',
        },
        'ola-mathisen': {
          role: 'Byggesaksbehandler',
          department: 'Plan- og bygningsetaten',
        },
        'maria-nguyen': {
          role: 'Geodatakoordinator',
          department: 'Bydel Grunerlokka',
        },
        'per-nygaard': {
          role: 'Beredskapsanalytiker',
          department: 'Brann- og redningsetaten',
        },
        'lina-johansen': {
          role: 'Digital bibliotekutvikler',
          department: 'Deichman bibliotek',
        },
        'emil-kristoffersen': {
          role: 'Juridisk radgiver',
          department: 'Kommuneadvokaten',
        },
        'sana-khan': {
          role: 'Tjenestedesigner',
          department: 'Velferdsetaten',
        },
        'bjorn-larsen': {
          role: 'Nettverksadministrator',
          department: 'Oslo kommune IKT',
        },
        'ida-myrvang': {
          role: 'Portefoljeleder',
          department: 'Byradsavdeling for byutvikling',
        },
        'christian-holmboe': {
          role: 'Data engineer',
          department: 'Oslo Origo',
        },
        'tuva-lie': {
          role: 'HR-systemforvalter',
          department: 'Byradslederens kontor',
        },
        'magnus-strand': {
          role: 'GIS-operator',
          department: 'Bymiljoetaten',
        },
        'anne-wold': {
          role: 'Saksarkivar',
          department: 'Kulturetaten',
        },
        'mohamed-yusuf': {
          role: 'Sikkerhetskoordinator',
          department: 'Sykehjemsetaten',
        },
        'ragnhild-sveen': {
          role: 'Avdelingsleder',
          department: 'Bydel Gamle Oslo',
        },
        'petter-hansen': {
          role: 'Datakatalogforvalter',
          department: 'Plan- og bygningsetaten',
        },
        'camilla-nilsen': {
          role: 'Testleder',
          department: 'Utviklings- og kompetanseetaten',
        },
        'henrik-iversen': {
          role: 'Entra-administrator',
          department: 'Oslo kommune IKT',
        },
        'solveig-rustad': {
          role: 'Informasjonsarkitekt',
          department: 'Byarkivet',
        },
        'daniel-bergum': {
          role: 'API-forvalter',
          department: 'Oslo Origo',
        },
        'emma-sorensen': {
          role: 'Prosjektcontroller',
          department: 'Vann- og avlopsetaten',
        },
      },
      right: {
        title: 'Sensitive infrastructure Oslo',
        shortTitle: 'Sensitive infrastructure Oslo',
        datasetName: 'Sensitive infrastructure - Oslo kommune',
        accessLevel: 'Tilgangsbegrensede data',
        description: 'Forvaltningsrettighet til tilgangsbegrenset kartlag via Geonorge.',
      },
      datasets: {
        'fkb-bygning-tiltak': {
          name: 'FKB Bygning og Tiltak',
          description: 'Bygg, tiltak og bygningsrelaterte kartdata.',
        },
        eiendomsgrenser: {
          name: 'Eiendomsgrenser',
          description: 'Matrikkelbaserte grenser og eiendomskoblinger.',
        },
        'va-ledningsdata': {
          name: 'Vann/avlop ledningsdata',
          description: 'Ledningsnett og teknisk infrastruktur for vann og avlop.',
        },
        'sarbar-infrastruktur': {
          name: 'Sensitive infrastructure',
          description: 'Tilgangsbegrenset infrastrukturlag for beredskap og sikker kommunal forvaltning.',
        },
      },
      districts: {
        oslo: 'Oslo kommune',
        'bydel-gamle-oslo': 'Bydel Gamle Oslo',
        'bydel-grunerlokka': 'Bydel Grunerlokka',
        'bydel-sagene': 'Bydel Sagene',
        'bydel-stovner': 'Bydel Stovner',
        'bydel-nordre-aker': 'Bydel Nordre Aker',
      },
      actions: {
        read: 'Innsyn',
        download: 'Nedlasting',
        edit: 'Redigering',
        'read-download': 'Innsyn, nedlasting',
      },
      assurance: {
        normal: 'Normal',
        high: 'Assurance level HIGH',
      },
      targets: {
        entra: 'Microsoft Entra ID',
        wallet: 'Digital lommebok (EUDI)',
      },
    },
    shell: {
      tenant: 'Oslo kommune IDA',
      requestManagement: 'Access request',
    },
    credential: {
      holder: 'Innehaver',
      pid: 'PID',
      right: 'Rettighet',
      dataset: 'Datatype',
      area: 'Omrade',
      action: 'Handling',
      assurance: 'Assurance level',
      validUntil: 'Gyldig til',
      status: 'Status',
      revoked: 'Revokert',
      active: 'Aktivt bevis',
      missing: 'Mangler',
      revokedSuffix: 'revokert',
    },
    admin: {
      eyebrow: 'Identity Governance',
      title: 'Identitets- og tilgangsstyring',
      phases: {
        creatingProof: 'Utsted lommebokbevis',
        informingUser: 'Varsle ansatt',
        done: 'Vedtak lagret',
      },
      openWallet: 'Åpne lommebok',
      activeCredential: 'Bevis aktivt',
      steps: {
        employee: 'Velg identitet',
        action: 'Velg rettighetstype',
        right: 'Spesifiser rettighet',
        provisioning: 'Lagring',
      },
      actionChoices: {
        grant: {
          title: 'GeoNorge forvaltningsrettighet',
          description: 'Deleger tilgang til Sensitive infrastructure-kartlaget for en valgt bydel.',
        },
        modify: {
          title: 'Endre tilgang',
          description: 'Endre den aktive demo-rettigheten for valgt ansatt.',
          unavailable: 'Ingen eksisterende demo-tilgang',
        },
        revoke: {
          title: 'Avslutt tilgang',
          description: 'Fjern aktiv Entra-tildeling og revoker eventuelt lommebokbevis.',
          unavailable: 'Ingen aktiv tilgang å avslutte',
        },
      },
      entitlementCatalog: {
        geonorge: {
          title: 'Sensitive infrastructure',
          description: 'Forvaltningsrettighet for kartlag, område og handlinger.',
        },
        matrikkel: {
          title: 'Matrikkeldata',
          description: 'Eiendom, bygg og adressegrunnlag for kommunal saksbehandling.',
        },
        planregister: {
          title: 'Planregister',
          description: 'Planstatus, regulering og arealformål for interne prosesser.',
        },
        byggesak: {
          title: 'Byggesak',
          description: 'Rettigheter knyttet til byggesaksflyt og vedtaksgrunnlag.',
        },
        beredskap: {
          title: 'Beredskapsdata',
          description: 'Skjermet tilgang til datasett brukt ved hendelser og øvelser.',
        },
      },
      noIdentityTitle: 'Ingen identitet valgt',
      noIdentityBody: 'Velg en identitet fra katalogen for å vurdere tilgang.',
      storage: {
        entraDescription: 'Gruppetildeling for intern tilgangsstyring.',
        entraHighUnavailable: 'Entra kan ikke gi Assurance level HIGH.',
        walletDescription: 'Utsted rettighetsbevis til ansatt.',
        notifyDescription: 'Send vedtak og eventuelt lommeboktilbud til ansatt.',
        chooseAtLeastOne: 'Velg minst ett lagringsmål',
      },
      provisioning: {
        assignEntra: 'Tildel Entra ID-gruppe',
        issueWallet: 'Utsted lommebokbevis',
        notifyEmployee: 'Varsle ansatt',
      },
      scope: {
        dataset: 'Datatype',
        area: 'Bydel',
        action: 'Handling',
        assurance: 'Assurance level',
        demoOnly: 'Demo',
        highWalletNotice:
          'Digital lommebok er påkrevd fordi Entra ikke kan gi Assurance level HIGH. Når rettigheten brukes, deler lommeboken PID sammen med rettighetsbeviset.',
        assuranceHelp: {
          normal: 'Standard tilgang kan lagres i Entra eller lommebok.',
          high: 'Lommebok kreves fordi datatypen trenger Assurance level HIGH ved bruk.',
        },
      },
      details: 'Detaljer',
      assignAccess: 'Lagre og utsted rettighet',
      saveChanges: 'Lagre endring',
      saveAccess: 'Lagre rettighet',
      removeUser: 'Fjern bruker - sluttet',
      popupBlocked: 'Tillat popup-vinduer, eller åpne lommebok fra demo-kontrollene i headeren.',
      selectedAccess: 'Valgt tilgang',
      employeeCount: '{count} ansattidentiteter',
      employeeDemoCount: '{count} i katalogutdrag',
      status: 'Status',
      employee: 'Ansatt',
      right: 'Rettighet',
      revokeSummary: 'Dette avslutter den aktive demo-rettigheten for {name}.',
      accessEnded: 'Tilgang avsluttet',
      assigned: 'Tildelt',
      readyToSave: 'Klar for lagring',
      endAccess: 'Avslutt tilgang',
      launcher: 'Demo launcher',
      resetScenario: 'Reset scenario',
      walletLink: 'Symfoni ID wallet',
      geonorgeLink: 'Geonorge',
    },
    audit: {
      ready: 'Request is ready for decision.',
      approved: '{time} Request approved for {name}. Targets: {targets}.',
      offerQueued: '{time} External credential offer queued for recipient.',
      credentialAccepted: '{time} {name} hentet beviset etter ID-porten mock-innlogging.',
      deprovisioned: '{time} {name} deprovisioned: {artifacts}.',
      revocationReason: '{name} er markert som sluttet i IGA.',
      artifacts: {
        entraRemoved: 'Microsoft Entra group removed',
        offerCanceled: 'external credential offer canceled',
        credentialRevoked: 'external credential revoked',
        none: 'no active entitlement found',
      },
    },
    wallet: {
      title: 'Symfoni ID personlommebok',
      subtitle: 'Mock EUDI wallet',
      offersTitle: 'Nye tilbud',
      emptyTitle: 'Ingen nye bevis',
      emptyBody: 'Du har ingen nye tilbud å håndtere.',
      newOffer: 'Nytt bevis tilbys',
      offerBody: 'Oslo kommune tilbyr {name} et forvaltningsbevis for GeoNorge.',
      issuer: 'Utsteder',
      issuerName: 'Oslo kommune IDA',
      receiveCredential: 'Motta bevis',
      idPortenTitle: 'ID-porten innlogging',
      idPortenSubtitle: 'Mock innlogging hos utsteder',
      idPortenHighSubtitle: 'Mock innlogging hos utsteder',
      person: 'Person',
      completeLogin: 'Gjennomfør innlogging',
      issuing: 'Henter bevis fra utsteder...',
      myCredentials: 'Mine bevis',
      pidCredential: {
        title: 'PID',
        description: 'Personidentitet klar for deling ved høy assurance.',
      },
      employeeCredential: {
        title: 'Oslo kommune ansattbevis',
        description: 'Bekrefter aktiv ansettelse og kommunal rolle.',
        role: 'Rolle',
        department: 'Virksomhet',
        employer: 'Arbeidsgiver',
        employerName: 'Oslo kommune',
        active: 'Aktivt arbeidsforhold',
      },
    },
    walletShare: {
      title: 'Symfoni ID',
      subtitle: 'Geonorge ber om PID og rettighetsbevis',
      heading: 'Del med Mock Geonorge',
      body: 'Lommeboken deler PID for Assurance level HIGH og forvaltningsbeviset for {right}.',
      pid: 'PID (Assurance level HIGH)',
      credential: 'Bevis',
      revokedWarning:
        'Beviset er markert som revokert, men kan fortsatt presenteres for negativ demo.',
      share: 'Del PID og bevis',
      shared: 'Presentasjonen er sendt til Geonorge.',
    },
    geonorge: {
      search: 'Søk i Geonorge',
      menu: 'Meny',
      breadcrumbCatalog: 'Kartkatalogen',
      breadcrumbLayer: 'Kartlag',
      title: 'Sensitive infrastructure',
      info1: 'Kartlaget viser tilgangsbegrenset infrastruktur for valgt forvaltningsområde.',
      info2: 'Basiskartet er åpent. Det sensitive laget krever wallet-basert presentasjon av PID og rettighetsbevis.',
      info3: 'Etter godkjent presentasjon vises laget som overlay i kartflaten.',
      readMore: 'Les mer om tilgangsbegrensede kartlag',
      accessStatusTitle: 'Tilgangsstatus',
      goHome: 'Gå til start',
      removeDataset: 'Fjern datasett',
      status: {
        processing: 'Kontrollerer tilgang...',
        approved: 'Sensitive infrastructure-laget er aktivt',
        denied: 'Du har ikke tilgang til dette datasettet.',
        idle: 'Logg inn for å se tilgangsbegrensede kartlag.',
      },
      popupBlocked: 'Tillat popup-vinduer, eller åpne `/wallet/share` i en egen fane.',
      loginWithWallet: 'Logg inn med lommebok',
      map: {
        title: 'GeoNorge kartflate for Sensitive infrastructure',
        baseMap: 'Basiskart',
        sensitiveLayer: 'Sensitivt infrastrukturlag',
        lockedLayer: 'Låst sensitivt lag',
        lockedBody: 'Presenter wallet-beviset for å vise Sensitive infrastructure i valgt område.',
        visibleLayer: 'Sensitive infrastructure synlig',
        oslo: 'Oslo',
      },
      panel: {
        statusTitle: 'Lagstatus',
        area: 'Område',
        layer: 'Kartlag',
        rights: 'Delegerte rettigheter',
        managementTitle: 'Forvaltning',
        managementBody: 'Redigering vises som delegert rettighet når den er valgt i IDA, men denne demoen har ingen redigeringsmodus.',
      },
      version: 'Versjon 14.5.2563',
      about: 'Om nettstedet',
      aboutItems: ['Om Geonorge', 'Personvern og bruk av cookies', 'Tilgjengelighetserklæring'],
      contact: 'Kontakt',
      phone: 'Telefon: 32 11 80 00',
      organizationNumber: 'Org. nr.: 971 040 238',
    },
    verification: {
      missingCredential: 'Ingen Geonorge-rettighet ble delt fra lommeboken.',
      pidMismatch: 'PID i presentasjonen matcher ikke bevisets innehaver.',
      wrongDataset: 'Beviset gjelder ikke riktig Geonorge-datasett.',
      insufficientAssurance: 'Denne datatypen krever Assurance level HIGH.',
      revoked: 'Beviset er revokert av Oslo kommune IGA.',
      expired: 'Beviset er utløpt.',
      approved: 'PID og rettighetsbevis er verifisert.',
    },
  },
} as const;
